export const cities = [
  {
    value: "sharjah",
    label: "Sharjah"
  },
  {
    value: "dubai",
    label: "Dubai"
  },
  {
    value: "ajman",
    label: "Ajman"
  },
  {
    value: "abu dhabi",
    label: "Abu Dhabi"
  },
  {
    value: "fujairah",
    label: "Fujairah"
  },
  {
    value: "ras al-khaimah",
    label: "Ra's al-Khaimah"
  },
  {
    value: "umm al-qaiwain",
    label: "Umm al-Qaiwain"
  },
];